export type LayerOrder = 'background' | 'foreground';

export default class BackgroundCommandEffectOptions {
  // eslint-disable-next-line no-useless-constructor
  constructor(public layerOrder?: LayerOrder) {}
}
